const actions = {
  reset({ commit }) {
    commit('SET_UPLOAD_EVENT', null)
    commit('SET_IMPORTER_ERROR', null)
    commit('SET_FETCHED_USERS', [])
    commit('SET_EXCEL_USERS', [])
  },
  setImporterHistory({ commit }, history) {
    commit('SET_IMPORTER_HISTORY', history)
  },
  setPointType({ commit }, pointType) {
    commit('SET_POINT_TYPE', pointType)
  },
  setUploadEvent({ commit }, event) {
    commit('SET_UPLOAD_EVENT', event)
  },
  setImporterError({ commit }, importerError) {
    commit('SET_IMPORTER_ERROR', importerError)
  },
  setUserGroups({ commit }, userGroups) {
    commit('SET_USER_GROUPS', userGroups)
  },
  setExtraPoints({ commit }, extraPoints) {
    commit('SET_EXTRA_POINTS', extraPoints)
  },
  resetImporterState({ commit }) {
    commit('RESET_IMPORTER_STATE')
  },
  unsetImporterState({ commit }, importState) {
    commit('UNSET_IMPORTER_STATE', importState)
  },
  setImporterState({ commit }, importState) {
    commit('SET_IMPORTER_STATE', importState)
  },
  setSelectedUser({ commit }, selectedUser) {
    commit('SET_SELECTED_USER', selectedUser)
  },
  setExcelUsers({ commit }, excelUsers) {
    commit('SET_EXCEL_USERS', excelUsers)
  },
  setFetchedUsers({ commit }, fetchedUsers) {
    commit('SET_FETCHED_USERS', fetchedUsers)
  },
  setExtraImportPoints({ commit }, extraImportPoints) {
    commit('SET_EXTRA_IMPORT_POINTS', extraImportPoints)
  },
  setImportPoints({ commit }, importPoints) {
    commit('SET_IMPORT_POINTS', importPoints)
  },
  setImporterType({ commit, getters }, type) {
    const importerType = getters.importerTypes.find((importer) => importer.id === type)

    if (importerType.config.pointsExpiration !== undefined) {
      const currentYear = new Date().getFullYear(),
        currentMonth = new Date().getMonth() + 1,
        currentDay = new Date().getDate()

      let pointsExpiration = importerType.config.pointsExpiration
        .replace('${YEAR}', currentYear)
        .replace('${MONTH}', currentMonth)
        .replace('${DAY}', currentDay)

      /**
       * pointsExpiration = 2026-04-01 (First April) >
       * new Date() = 2026-03-04
       * Use last year as pointsExpiration to avoid having points
       * that expire in actual year when the importer is used
       * before the pointsExpiration date.
       */
      if (new Date(pointsExpiration) > new Date()) {
        pointsExpiration = importerType.config.pointsExpiration
          .replace('${YEAR}', currentYear - 1)
          .replace('${MONTH}', currentMonth)
          .replace('${DAY}', currentDay)
      }

      importerType.config.pointsExpiration = pointsExpiration
    }

    commit('SET_IMPORTER_TYPE', importerType)
  },
  setImporterTypes({ commit }, response) {
    commit('SET_IMPORTER_TYPES', response)
  }
}

export { actions }
